import { Input, Button, Form, DatePicker, Rate } from 'rsuite';


const Field = ({ error, help, as: Component = Input, ...rest }) => {
    return (
      <Form.Group className={rest.className}>
        <Form.ControlLabel>{rest.label}</Form.ControlLabel>
        <Component {...rest} />
        <Form.ErrorMessage show={!!error} placement="bottomStart">
          {error}
        </Form.ErrorMessage>
        <Form.HelpText>{help}</Form.HelpText>
      </Form.Group>
    );
  };

export default Field